import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useTranslations } from "next-intl"
import { useRouter } from "next/router"

interface PlanInsufficientAlertProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  message?: string
  onAction?: () => void
}

export default function PlanInsufficientAlert({
  isOpen,
  onOpenChange,
  title,
  message,
  onAction,
}: PlanInsufficientAlertProps) {
  const t = useTranslations("Common")
  const router = useRouter()

  const handleCheckPlan = () => {
    if (onAction) {
      onAction()
    } else {
      router.push("/pricing")
    }
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {title || t("Message.limitReached")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {message || t("Message.limitReachedDescription")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("Action.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={handleCheckPlan}>
            {t("Action.checkPlan")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
